import { rasterizeSvg } from "./rasterize";

export interface TabIcon {
  uri: string;
  scale: number;
}

const SCALE = 3;
const ICON_SIZE = 24;

/** Keyed by SVG source. The PNGs are template images, tinted by the bar. */
const cache = new Map<string, Promise<TabIcon | undefined>>();

/** Rasterise `svg` for the native tab bar. Resolves undefined if it cannot be drawn. */
export function loadTabIcon(svg: string): Promise<TabIcon | undefined> {
  let pending = cache.get(svg);
  if (!pending) {
    pending = rasterizeSvg(svg, ICON_SIZE, SCALE).then((uri) => (uri ? { uri, scale: SCALE } : undefined));
    cache.set(svg, pending);
  }
  return pending;
}
